const state = {
  currInvoice: null
}

const mutations = {
  SET_INVOICE: (state, invoice) => {
    state.currInvoice = invoice
  }
}

const actions = {
  setInvoice({ commit }, invoice) {
    commit('SET_INVOICE', invoice)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice.js